import {decorate, observable} from "mobx";

class FormModelStore {
    get recentlyChangedFormSection(): string {
        return this._recentlyChangedFormSection;
    }

    set recentlyChangedFormSection(value: string) {
        this._recentlyChangedFormSection = value;
    }

    formModel: any;
    recentlyChangedField: string = '';
    private _recentlyChangedFormSection: string = '';
    dirty: boolean = false;

    setRecentlyChangedField(field: string): void {
        this.recentlyChangedField = field;
    }

    setFormModel(model: any): void {
        this.formModel = model;
    }

    setDirty(dirty: boolean) {
        this.dirty = dirty;
    }

    setFormModelValue(key: string, value: any) {
        let path = key.split('.')
        let current = this.formModel
        for (const element of path) {
            current = current[element]
        }
        current.value = value
    }

    getFormModelProperty(path: string, propertyName: string) {
        let paths = path.split('.')
        let current = this.formModel
        for (const element of paths) {
            if (!current) {
                return undefined;
            }

            current = current[element]
        }

        if (!current) {
            return undefined;
        }

        if (propertyName in current) {
            return current[propertyName]
        }

        return undefined
    }

    setFormModelProperty(path: string, propertyName: string, value: any) {
        let paths = path.split('.')
        let current = this.formModel
        for (const element of paths) {
            if (!current) {
                return;
            }

            current = current[element]
        }

        current[propertyName] = value;
    }
}

decorate(FormModelStore, {
    formModel: observable,
    dirty: observable,
    recentlyChangedField: observable
})
const formModelStore = new FormModelStore();
export default formModelStore;
